"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = __importDefault(require("gsap"));
const Util_1 = __importDefault(require("../../Util"));
const vs = `
  attribute float size;
  uniform float u_timeVertex;

  float random (vec2 st) {
    return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
  }
  
  void main() {
    gl_PointSize = size;
    vec3 pos = position;

    float rand = random(vec2(size));
    pos.y += sin(u_timeVertex * rand) * 0.2;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
  }
`;
const fs = `
  precision mediump float;
  uniform sampler2D u_texture;
  uniform float u_time;
  uniform vec3 fogColor;
  uniform float fogNear;
  uniform float fogFar;

  void main() {
    vec4 color = texture2D(u_texture, gl_PointCoord);
    if (color.a > 0.1) {
      color.rgb = vec3(0.0);
    } 
    gl_FragColor = color;
    #ifdef USE_FOG
      #ifdef USE_LOGDEPTHBUF_EXT
        float depth = gl_FragDepthEXT / gl_FragCoord.w;
      #else
        float depth = gl_FragCoord.z / gl_FragCoord.w;
      #endif
      float fogFactor = smoothstep( fogNear, fogFar, depth );
      gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      //gl_FragColor = vec4(gl_FragCoord.z);
    #endif
  }
`;
class SpreadCircle extends THREE.Object3D {
    constructor(width = 1, height = 1, texture) {
        super();
        this.PARTICLE_NUM = 2000;
        this.width = width;
        this.height = height;
        this.shape = null;
        this.wireframe = null;
        this.balls = [];
        this.uniforms = {
            u_time: { value: 0.0 },
            u_timeVertex: { value: 0.0 },
            u_texture: { value: texture },
            fogColor: { type: 'c', value: new THREE.Color() },
            fogNear: { type: 'f', value: 0.0 },
            fogFar: { type: 'f', value: 0.0 },
        };
        this.vectors = [];
        this._vectors = [];
        this.particleSystem = null;
        this.container = new THREE.Object3D();
        this.add(this.container);
        this.fake = null;
        this.geo = null;
        this._createFake(texture);
        this._createShape();
        this.isShowParticle = false;
    }
    draw(cb) {
        if (this.fake) {
            gsap_1.default.to(this.fake.material, { duration: 0.3, opacity: 1 });
            gsap_1.default.to(this.fake.scale, {
                duration: 0.7,
                x: 0.8,
                y: 0.8,
                ease: 'back.out(1.7)',
            });
        }
        gsap_1.default.delayedCall(0.1, () => {
            if (this.particleSystem)
                this.particleSystem.visible = true;
            this._spread();
            this.isShowParticle = true;
            gsap_1.default.delayedCall(0.1, () => {
                if (this.fake) {
                    this.fake.visible = false;
                    this.fake.scale.set(0.2, 0.2, 1);
                }
            });
            this.particleSystem &&
                gsap_1.default.to(this.particleSystem.rotation, 2, { x: 0.1 });
        });
        gsap_1.default.delayedCall(1, () => cb());
    }
    hide(cb) {
        gsap_1.default.to(this.container.rotation, {
            duration: 1.6,
            x: Math.PI / 2,
            ease: 'power3.inOut',
        });
        gsap_1.default.to(this.container.position, {
            duration: 2,
            z: -250,
            ease: 'power4.inOut',
        });
        gsap_1.default.delayedCall(1.4, () => {
            this._hide();
            gsap_1.default.killTweensOf(this.container.position);
            gsap_1.default.to(this.container.position, {
                duration: 2.5,
                z: 14,
                ease: 'power4.inOut',
            });
        });
        gsap_1.default.delayedCall(4.4, () => {
            cb();
        });
    }
    update() {
        this.uniforms.u_time.value += 0.02;
        if (this.isShowParticle)
            this.uniforms.u_timeVertex.value += 0.02;
        if (this.particleSystem)
            this.particleSystem.rotation.y -= 0.002;
    }
    setFog(fog) {
        this.uniforms.fogColor = { type: 'c', value: fog.color };
        this.uniforms.fogNear = { type: 'f', value: fog.near };
        this.uniforms.fogFar = { type: 'f', value: fog.far };
    }
    _spread() {
        if (!this.geo)
            return;
        const positions = this.geo.attributes.position;
        const size = this.geo.attributes.size;
        const temp = new THREE.Vector3();
        const duration = 1.6;
        const delay = 0.4;
        let radius = 0;
        for (let i = 0; i < this.PARTICLE_NUM; i++) {
            const v = this.vectors[i];
            const j = i;
            radius = Math.random() * 8 + 1;
            size.setX(i, Util_1.default.map(radius, 1, 10, 30, 1));
            temp.set(Util_1.default.random(-0.5, 0.5), 0, Util_1.default.random(-0.5, 0.5));
            temp.normalize();
            temp.setLength(radius);
            gsap_1.default.to(v, {
                delay: Util_1.default.random(0, 0),
                duration: duration,
                x: temp.x,
                y: temp.y,
                z: temp.z,
                ease: 'back.out(1.5)',
                onUpdate: () => {
                    if (this.geo) {
                        positions.setX(j, v.x);
                        positions.setY(j, v.y);
                        positions.setZ(j, v.z);
                    }
                },
            });
        }
        this.geo.attributes.size.needsUpdate = true;
        gsap_1.default.to({ temp: 1 }, {
            duration: duration + delay,
            temp: 2,
            onUpdate: () => {
                if (this.geo) {
                    this.geo.attributes.position.needsUpdate = true;
                    this.geo.attributes.size.needsUpdate = true;
                }
            },
        });
    }
    _hide() {
        if (!this.geo)
            return;
        const position = this.geo.attributes.position;
        for (let i = 0; i < this.PARTICLE_NUM; i++) {
            const v = this.vectors[i];
            const j = i * 3;
            const y = Util_1.default.random(0, 100);
            gsap_1.default.to(v, {
                delay: 0.4,
                duration: 2,
                y: y,
                ease: 'power2.inOut',
                onUpdate: () => {
                    position.setY(j, v.y);
                },
            });
        }
        if (this.geo)
            this.geo.attributes.size.needsUpdate = true;
        gsap_1.default.to({ temp: 1 }, {
            duration: 2.4,
            temp: 2,
            onUpdate: () => {
                if (this.geo)
                    this.geo.attributes.position.needsUpdate = true;
            },
        });
    }
    _createShape() {
        const positions = [];
        const sizes = [];
        const geo = new THREE.BufferGeometry();
        const mat = new THREE.ShaderMaterial({
            vertexShader: vs,
            fragmentShader: fs,
            uniforms: this.uniforms,
            transparent: true,
            depthTest: false,
            side: THREE.FrontSide,
            fog: true,
        });
        for (let i = 0; i < this.PARTICLE_NUM; i++) {
            this.vectors.push(new THREE.Vector3());
            this._vectors.push(i);
            positions.push(0, 0, 0);
            sizes.push(30);
        }
        geo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        geo.setAttribute('size', new THREE.Float32BufferAttribute(sizes, 1).setUsage(THREE.DynamicDrawUsage));
        this.particleSystem = new THREE.Points(geo, mat);
        this.particleSystem.visible = false;
        this.container.add(this.particleSystem);
        this.geo = geo;
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.container.add(this.wireframe);
    }
    _createFake(texture) {
        const geo = new THREE.PlaneBufferGeometry(0.25, 0.25, 1, 1);
        const mat = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,
            opacity: 0,
        });
        this.fake = new THREE.Mesh(geo, mat);
        this.fake.scale.set(0.1, 0.1, 1);
        this.fake.position.z = 0.1;
        this.add(this.fake);
    }
}
exports.default = SpreadCircle;
